import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "pa-2",
  style: {"width":"50%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Functional Location")
  ])
], -1)

import { AssetManagementPlan, FunctionalLocation } from "@/classes";
import RichText from "@/components/base/inputs/RichText.vue";
import FunctionalLocationDialog from "@/components/functional-location/FunctionalLocationDialog.vue";
import FunctionalLocationTree from "@/components/functional-location/tree/FunctionalLocationTree.vue";
import { TreeItem } from "@/components/functional-location/tree/tree";
import { computed, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DiffScopeBoundaryLimits',
  props: {
    plan: {},
    diffPlan: {},
    diff: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const flocTree = ref<InstanceType<typeof FunctionalLocationTree> | null>(null);
const flocDialog = ref<InstanceType<typeof FunctionalLocationDialog> | null>(
  null,
);

const treeItems = ref<TreeItem<FunctionalLocation>[]>([]);

// Display tree items in same order as boundary list
const sortedTreeItems = computed(() => {
  const items: TreeItem<FunctionalLocation>[] = [];
  if (props.plan) {
    props.plan.floc_boundaries.forEach((bound) => {
      const item = treeItems.value.find(
        (i) => i.item.id === bound.functional_location_id,
      );
      if (item) items.push(item);
    });
  }
  return items;
});

watch(
  () => props.plan?.id,
  async () => {
    if (props.plan) {
      const flocIds: string[] = [];
      for (const bound of props.plan.floc_boundaries) {
        const exist = treeItems.value.find(
          (item) => item.item.id === bound.functional_location_id,
        );
        if (!exist) flocIds.push(bound.functional_location_id);
      }
      const flocs = await FunctionalLocation.getTreeChildren({
        parent_id: null,
        floc_ids: flocIds,
      });
      for (const floc of flocs) {
        const item = {
          item: floc,
          expanded: false,
          children: null,
        } as TreeItem<FunctionalLocation>;
        treeItems.value.push(item);
      }
    }
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.context_general_information ?? '',
      "diff-value": _ctx.diffPlan?.context_general_information,
      label: "3.1 Context & General Information",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(_component_v_card, {
      class: "mb-4",
      variant: "outlined",
      rounded: "lg"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_toolbar, { density: "compact" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar_title, null, {
              default: _withCtx(() => [
                _createTextVNode("3.2 Boundary Limits")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_table, {
          "fixed-header": "",
          density: "compact",
          class: "boundary-limits-table"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan?.floc_boundaries ?? [], (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.functional_location.functional_location), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      variant: "outlined",
      rounded: "lg"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_toolbar, { density: "compact" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar_title, null, {
              default: _withCtx(() => [
                _createTextVNode("3.3 Boundary Limits Tree")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(FunctionalLocationTree, {
          ref_key: "flocTree",
          ref: flocTree,
          "tree-items": sortedTreeItems.value,
          "max-height": "500px",
          onView: _cache[0] || (_cache[0] = ($event: any) => (flocDialog.value?.open($event.item.id)))
        }, null, 8, ["tree-items"]),
        _createVNode(FunctionalLocationDialog, {
          ref_key: "flocDialog",
          ref: flocDialog,
          readonly: ""
        }, null, 512)
      ]),
      _: 1
    })
  ]))
}
}

})